namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmMailSchranka extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmMailSchrankaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmMailSchrankaObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmMailSchrankaObj());
            this.detailObj.createBase({
                contentName: "detailAdmMailSchranka",
                contentCaption: "jres:33000405", //RC 33000405 : Mail schránka
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getAutomatickeMotoryTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getAutomatickeMotoryGroup())
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmMailSchranka", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmMailSchrankaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmMailSchrankaReadDto> {
        private srv: GContent;

        private getSrv(): GContent {
            if (!this.srv)
                this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailAdmMailSchranka");
            return this.srv;
        }

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["mailbox"]
        }

        setSxsDetail(): string {
            return (this.data.mailbox) ? this.data.mailbox : "";
        }

        saveBase(close: boolean) {
            this.hideAllFlash();
            var form = this.cnt.findForms("{0}form".format(this.options.contentName));
            var novaData: any = {};
            form.gform("waitForValues").done(() => {
                if (form.gform("isValid")) {
                    return Prefabs.GStringBox.updateChiperPublicKeys(form).then(() => {
                        form.findFields().gfield("model", "collect", novaData);
                        this.saveData(novaData, close);
                    })
                }
            })
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmMailSchrankaSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (data.NewRecord == true)
                data.change_passwd = 10;
            if (data.priz_ba == 0) {
                data.ixs_oap = null;
            } else {
                data.change_passwd = 0;
            }
            this.getSrv().call("SaveMailSchranka", { mailSchranka: data }).done((output) => { 
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmMailSchranka", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmMailSchranka.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.mailbox) ? this.data.mailbox : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.form.form.layoutDescriptor = "L2M2S1";
            this.MakeSection("");
            this.MakeField("mailbox")
            this.MakeSelectField("typ_mbx", Gordic.Prefabs.Select.gincmbx(), {
                model: "model.typ_mbx=value.typ_mbx",
                serverFilters: { typ_mbx: [10, 20 ] },
                dropdown: true
            })
            this.MakeField("nazev");
            this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                model: "model.ixs_su=value.ixs_su",
            })
            this.MakeSelectField("priz_automat", Gordic.Prefabs.Select.admGincpat(), {
                model: "model.priz_automat=value.priz_automat",
            })
            this.MakeSelectField("priz_ba", Gordic.Prefabs.Select.admGincpba(), {
                name: "priz_ba",
                model: "model.priz_ba=value.priz_ba",
                dropdown: true,
                change: (ev, ctx) => {
                    this.HideField("server_name")
                    this.HideField("port")
                    this.HideField("priz_ssl")
                    this.HideField("pdb1")
                    this.HideField("pdb2")
                    this.HideField("change_passwd")
                    this.HideField("ixs_oap")
                    this.HideField("zpusob_ulozeni_hesla")
                    this.HideField("password_map")
                    var form = this.cnt.findForms("{0}form".format(this.options.contentName))
                    var login = "jres:33000285";
                    form.findFormRows("row_login_txt").find("label")
                    var ixsOapField = form.findFields("ixs_oap");
                    ixsOapField.gfield("option", {
                        flag: null,
                        validators: []
                    })
                    if (ctx.value != null && ctx.value != undefined) {
                        if (!Array.isArray(ctx.value)) {
                            if (ctx.value.priz_ba == 0) {
                                this.ShowField("port")
                                this.ShowField("priz_ssl")
                                this.ShowField("server_name")
                                this.ShowField("pdb1")
                                this.ShowField("pdb2")
                                this.ShowField("change_passwd")
                                this.ShowField("zpusob_ulozeni_hesla")
                                this.ShowField("password_map")
                                this.hesloOpenFields();
                            } else if (ctx.value.priz_ba == 10 || ctx.value.priz_ba == 20) {
                                this.ShowField("ixs_oap");
                                ixsOapField.gfield("option", {
                                    flag: "required",
                                    validators: [new Gordic.Validators.Required({ stopping: true })]
                                })
                                login = "jres:33000405"
                            }
                        }
                    }
                    form.findFormRows("row_login_txt").find("label").html(login)
                }
            })
            this.MakeField("server_name");
            this.MakeField("port", {
                emptyValue: null
            })
            this.MakeSelectField("priz_ssl", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_ssl=value.priz_an" })
            this.MakeField("login_txt")
            if (this.options.newRecord == false) {
                this.MakeBool10Field("change_passwd", {
                    change: (ev, ctx) => {
                        var form = this.cnt.findForms("{0}form".format(this.options.contentName))
                        var pdb1 = form.findFields("pdb1")
                        var pdb2 = form.findFields("pdb2")
                        var zpusob = form.findFields("zpusob_ulozeni_hesla")
                        var map = form.findFields("password_map")
                        if (ctx.value == true) {
                            pdb1.gfield("enable")
                            pdb2.gfield("enable")
                            zpusob.gfield("enable")
                            map.gfield("enable")
                        } else {
                            pdb1.gfield("disable")
                            pdb2.gfield("disable")
                            zpusob.gfield("disable")
                            map.gfield("disable")
                        }
                    }
                })
            }
            this.form.addRow({ label: "jres:33000631", name: "zpusob_ulozeni_hesla" }).addField("gradio", {
                name: "zpusob_ulozeni_hesla",
                disabled: !this.editMode,
                itemClass: "w-12",
                radios: [
                    { value: 0, label: "jres:33000632" }, //RC 33000632 : Databáze
                    { value: 10, label: "jres:33000633" }, //RC 33000633 : Přímé mapování
                    { value: 20, label: "jres:33000634" } //RC 33000634 : Nepřímé mapování
                ],
                change: (ev, ctx) => {
                    this.hesloOpenFields();
                }
            })
            this.form.addRow({ label: "jres:30028702", name: "pdb1_row"}).addField("gstringbox", Gordic.Prefabs.GStringBox.password({
                obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
            }), {
                name: "pdb1",
                disabled: !this.editMode,
                validators: [this.createSpecialValidator()],
                tag: {
                    text: "jres:33000289",
                    state: "info"
                }
            })
            this.form.addRow({ label: "jres:33000406", name: "pdb2_row" }).addField("gstringbox", Gordic.Prefabs.GStringBox.password({ //RC 33000406 : Heslo znovu
                obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
            }), {
                name: "pdb2",
                disabled: !this.editMode,
                tag: {
                    text: "jres:33000289",
                    state: "info"
                }
            })
            this.form.addRow({ label: "jres:33000635", name: "password_map_row" }).addField("gstringbox", {
                name: "password_map",
                disabled: !this.editMode,
                flag: "required",
                tag: {
                    text: "jres:33000644", //RC 33000644 : Sem nezadávejte heslo ale pouze informaci, kde je heslo uloženo (odkaz, identifikátor)!
                    state: "warning"
                }
            })
            this.MakeSelectField("ixs_oap", Gordic.Prefabs.Select.ginsoap(), {
                model: "model.ixs_oap=value.ixs_oap",
                dropdown: true,
            })
           
            this.MakeSection("")
            //this.MakeSelectField("ixs_cer", Gordic.Prefabs.Select.wflscer(), {
            //    model: "model.ixs_cer=value.ixs_cer",
            //    serverFilters: {
            //        aktivita: 100,
            //    },
            //    itemTemplate: "{jmeno_txt:trim:encode}<br><i>{otisk:trim:encode}</i>",
            //    graphicInput: "oninput",
            //    dropdown: true,
            //})
            //this.MakeBoolField("priz_main", {
            //    change: (ev, ctx) => {
            //        if (ctx.value == false)
            //            this.cnt.findFields("ixs_su_main").gfield("enable")
            //        else
            //            this.cnt.findFields("ixs_su_main").gfield("disable")
            //    }
            //})
            //this.MakeSelectField("ixs_su_main", {
            //    model: "model.ixs_su_main=value.ixs_su",
            //    modelValueTransform: {
            //        apply: function (modelValue) { return modelValue },
            //        collect: (fieldValue) => {
            //            var value = this.cnt.findFields("priz_main").gfield("getValue");
            //            if (value == false)
            //                return fieldValue.ixs_su
            //            else
            //                null;
            //        }
            //    }
            //})
            this.MakeField("db_name")
            this.MakeField("typ_db")
            this.MakeField("servername32")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" });
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            this.MakeField("dat_zmena");
        }

        private createSpecialValidator(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000252" })
            validator.stopping = true;
            validator.validate = (value, source) => {
                var form = this.cnt.findForms("{0}form".format(this.options.contentName));
                var changePasswd = form.findFields("change_passwd").gfield("getValue")
                var typeAut = form.findFields("priz_ba").gfield("getValue");
                var pdb1 = form.findFields("pdb1").gfield("getValue");
                var pdb2 = form.findFields("pdb2").gfield("getValue");
                if (changePasswd == true) {
                    if (typeAut != null && typeAut != undefined) {
                        if (typeAut["priz_ba"] == 0) {
                            if (pdb1 == pdb2)
                                return true
                            else 
                                return false
                        } else return true
                    } else return true;
                } else return true
            }
            return validator;
        }

        private hesloOpenFields() {
            var zpusobUlozeniHesla = this.cnt.findFields("zpusob_ulozeni_hesla").gfield("getValue");
            this.cnt.findFields("password_map").gfield("setValidators", []);
            this.HideField("pdb1")
            this.HideField("pdb2")
            this.HideField("password_map")
            if (zpusobUlozeniHesla == 0) {
                this.ShowField("pdb1")
                this.ShowField("pdb2")
            } else if (zpusobUlozeniHesla == 20) {
                this.ShowField("password_map")
                this.cnt.findFields("password_map").gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
            }
        }

        getAutomatickeMotoryTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-automaticke-motory-epa",
                    title: "jres:33001024",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-automaticke-motory-epa" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmMotorZpracovaniEPA",
                    serverParams: {
                        ID: "SeznamAdmMotorZpracovaniEPA",
                        mailbox: this.data.mailbox,
                        typ_mbx: this.data.typ_mbx,
                        tabOpen: true
                    }
                }
            }
        }

        getAutomatickeMotoryGroup(): IGTabGroupOptions {
            return { id: "_tab-automaticke-motory-epa", caption: "jres:33001024" }
        }
    }
}